import { render, staticRenderFns } from "./OracleCloseOrderFailure.vue?vue&type=template&id=42b5864c&scoped=true"
import script from "./OracleCloseOrderFailure.vue?vue&type=script&lang=js"
export * from "./OracleCloseOrderFailure.vue?vue&type=script&lang=js"
import style0 from "./OracleCloseOrderFailure.vue?vue&type=style&index=0&id=42b5864c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b5864c",
  null
  
)

export default component.exports